import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-multi-select',
  styleUrls: ['form-multiselect.component.scss'],
  template: `
    <mat-form-field class="col-12">
      <mat-label>{{ to.label }}</mat-label>
      <mat-select
        multiple
        class="w-100"
        [formControl]="formControl"
        [placeholder]="props.placeholder"
        [formlyAttributes]="field"
        [required]="props.required"
      >
        @for (opt of to?.options; track opt) {
          <mat-option [value]="opt.value">
            {{ opt.label }}
          </mat-option>
        }
      </mat-select>
      @if (props.help) {
        <span
          matTooltip="{{ props.help }}"
          aria-label="help"
          tabindex="0"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'rb-tooltip'"
        >
          <mat-icon class="col-1 help-icon"> help </mat-icon>
        </span>
      }
      @if (
        formControl.hasError('required') && !formControl.hasError('regRequired')
      ) {
        <mat-error>This field is required</mat-error>
      }
      @if (formControl.hasError('regRequired')) {
        <mat-error
          >This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.</mat-error
        >
      }
    </mat-form-field>
  `,
  imports: [
    FormlyModule,
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
})
export class FormlyMultiSelectComponent extends FieldType {}
